<template>
  <uidialog v-model="dialogOpen" :headerclass="headerclass" :acceptbutton="(acceptbutton!=false)?accept:null" closebutton='true' headericon=":icon" :title="title" size="lg" :waitbuttons="updating" ref="actiondlg">
    <div :style="{ width:awidth,height:aheight }" class="actiondlgbody">
      <span ref="inhtml"></span>
    </div>
  </uidialog>
</template>

<script>
import axios from 'axios';
import qs from 'qs';

export default {
  name: "ActionDialog",
  props:["action","width","height","value","params","buttons","acceptbutton","headerclass","title","icon"],
  data(){
    return {
      dialogid:null,
      awidth:this.width??"80vw",
      aheight:this.height??"60vh",
      htmltext:"<img src='icons/loading.gif'/>",
      dialogOpen:false
    }
  },
  methods:{
    open(){
      axios.post("headless.php?action="+this.action,qs.stringify({ ...this.params,dialogid:this.dialogid })).then(d=>{
        this.setInnerHTML(this.$refs.inhtml,d.data);
        setTimeout(()=>{
          this.$refs.inhtml.querySelector('.actionreturnvalue').addEventListener("accept",ev=> {
            this.accept1(ev.detail);
          },false);
        },1000);
      });
      this.dialogOpen=true;
    },
    accept(){
      let v=this.$refs.inhtml.querySelector('.actionreturnvalue')?.innerHTML;
      this.accept1((v!=null)?JSON.parse(v):null);
    },
    accept1(v){
      if (v!=null)
      {
        this.$emit('input',v);
        if (typeof this.acceptbutton=='function') this.acceptbutton(v);
      }
      this.dialogOpen=false;
    },
    setInnerHTML(elm, html) {
      elm.innerHTML = html;
      Array.from(elm.querySelectorAll("script")).forEach( oldScript => {
        const newScript = document.createElement("script");
        Array.from(oldScript.attributes)
            .forEach( attr => newScript.setAttribute(attr.name, attr.value) );
        newScript.appendChild(document.createTextNode(oldScript.innerHTML));
        oldScript.parentNode.replaceChild(newScript, oldScript);
      });
    }
  },
  mounted(){
    this.dialogid=this._uid;
  }
}
</script>

<style scoped>
  .actiondlgbody
  {
    overflow: auto;
  }

</style>